import { observer } from 'mobx-react'

import { useSelectionState } from 'modules/shift_management/hooks/useSelection'
import type { EmployeeWithShifts, RestDay } from 'modules/shift_management/lib/types'

import RestDayLayout from './RestDayLayout'

interface Props {
  restDay: RestDay
  employee: EmployeeWithShifts
}

const RestDayCell = ({ restDay, employee }: Props) => {
  const { restDays, isEnabled: isSelectionEnabled } = useSelectionState()
  const isSelected = !!restDays[restDay.id]

  return (
    <RestDayLayout
      restDay={restDay}
      employee={employee}
      isSelectionEnabled={isSelectionEnabled}
      isSelected={isSelected}
    />
  )
}

export default observer(RestDayCell)
